// constants/envelopeStyles.js - Envelope Style Constants for Greeting Cards

export const ENVELOPE_STYLES = [
  {
    id: 'classic',
    name: 'Classic',
    preview: '#D4B896',
    bodyColors: ['#f5e6d3', '#e8dcc9', '#d4b896'],
    topFlapColor: '#e8dcc9',
    bottomFlapColor: '#d9ccb8',
    borderColor: 'rgba(139, 92, 46, 0.15)',
    ribbonColor: '#c9a882',
    bowColor: '#d4af7a',
  },
  {
    id: 'red',
    name: 'Red Velvet',
    preview: '#DC143C',
    bodyColors: ['#FF6B6B', '#DC143C', '#C41E3A'],
    topFlapColor: '#DC143C',
    bottomFlapColor: '#C41E3A',
    borderColor: 'rgba(139, 0, 0, 0.2)',
    ribbonColor: '#FFD700',
    bowColor: '#FFA500',
  },
  {
    id: 'blue',
    name: 'Ocean Blue',
    preview: '#4169E1',
    bodyColors: ['#87CEEB', '#4169E1', '#1E90FF'],
    topFlapColor: '#4169E1',
    bottomFlapColor: '#1E90FF',
    borderColor: 'rgba(0, 0, 139, 0.2)',
    ribbonColor: '#F0E68C',
    bowColor: '#FFD700',
  },
  {
    id: 'green',
    name: 'Forest Green',
    preview: '#228B22',
    bodyColors: ['#90EE90', '#228B22', '#006400'],
    topFlapColor: '#228B22',
    bottomFlapColor: '#006400',
    borderColor: 'rgba(0, 100, 0, 0.2)',
    ribbonColor: '#FFD700',
    bowColor: '#FFA500',
  },
  {
    id: 'purple',
    name: 'Royal Purple',
    preview: '#7C4DFF',
    bodyColors: ['#B19CD9', '#7C4DFF', '#6A3DE8'],
    topFlapColor: '#7C4DFF',
    bottomFlapColor: '#6A3DE8',
    borderColor: 'rgba(75, 0, 130, 0.2)',
    ribbonColor: '#FFD700',
    bowColor: '#FFA500',
  },
  {
    id: 'pink',
    name: 'Pink Blush',
    preview: '#FF69B4',
    bodyColors: ['#FFB6C1', '#FF69B4', '#FF1493'],
    topFlapColor: '#FF69B4',
    bottomFlapColor: '#FF1493',
    borderColor: 'rgba(199, 21, 133, 0.2)',
    ribbonColor: '#FFD700',
    bowColor: '#FFA500',
  },
  {
    id: 'gold',
    name: 'Golden',
    preview: '#FFD700',
    bodyColors: ['#FFF8DC', '#FFD700', '#DAA520'],
    topFlapColor: '#FFD700',
    bottomFlapColor: '#DAA520',
    borderColor: 'rgba(184, 134, 11, 0.2)',
    ribbonColor: '#8B4513',
    bowColor: '#A0522D',
  },
  {
    id: 'silver',
    name: 'Silver Mist',
    preview: '#C0C0C0',
    bodyColors: ['#F5F5F5', '#C0C0C0', '#A9A9A9'],
    topFlapColor: '#C0C0C0',
    bottomFlapColor: '#A9A9A9',
    borderColor: 'rgba(105, 105, 105, 0.2)',
    ribbonColor: '#4169E1',
    bowColor: '#1E90FF',
  },
];

export const getEnvelopeStyleById = (id) => {
  return ENVELOPE_STYLES.find(style => style.id === id) || ENVELOPE_STYLES[0];
};

export default ENVELOPE_STYLES;
